var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.block,style:({
    '--background': ("url(" + (_vm.data[0].icon) + ")"),
  })},[_c('div',{class:_vm._.bg,on:{"click":_vm.jump}},[_c('van-notice-bar',{attrs:{"text":_vm.text,"speed":30}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }